export default __webpack_public_path__ + "static/media/goodscan.d5f3a5bf.wav";